<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual text="유통 ∙ 물류 ∙ IT기업의 협업 연계를 통한 성장과 유통산업의 혁신 성장을 이끄는 스타트업 생태계 구축을 추구합니다." src="/images/sub/sub-visual-pitching-festa.jpg">
                <template #titleContents>
                    <div class="sub-visual__tit-wrap mt-n20px">
                        <h2 class="sub-visual__tit"><span class="font-size-lg-100 font-weight-bold">e</span>커머스피칭페스타 소개</h2>
                    </div>
                </template>
            </sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <template v-if="festa">
            <!-- S: 행사 소개 -->
            <page-section title="행사소개" class="page-section--first">
                <div class="tit-wrap pb-0">
                    <h3 class="tit tit--xl" data-aos="fade-right" data-aos-delay="100">
                        <div v-html="festa.section2.txt[0]?.replace(/\n/g, '<br/>')" />
                    </h3>
                    <div class="txt txt--lg txt--dark" data-aos="fade-right" data-aos-delay="200">
                        <div v-html="festa.section2.txt[1]?.replace(/\n/g, '<br/>')" />
                    </div>
                </div>
                <div class="page-section__bg" style="background-image:url(/images/common/grey-bg.png);"></div>
            </page-section>
            <!-- E: 행사 소개 -->

            <!-- S: 행사 개요 -->
            <page-section title="행사개요" class="pb-0">
                <table-primary>
                    <table-primary-row v-for="(item, index) in festa.section3.table.list" :key="index">
                        <template #title>
                            <span v-html="item.title.replace(/\n/g, '<br />')" />
                        </template>
                        <template #text>
                            <p v-html="item.input.replace(/\n/g, '<br />')" />
                        </template>
                    </table-primary-row>
                </table-primary>
            </page-section>
            <!-- E: 행사 개요 -->

            <!-- S: 프로세스 -->
            <page-section title="프로세스" class="pb-0">
                <v-img src="/images/sub/pitching-festa/process-img-mo.png" class="d-md-none"  data-aos="fade-up" data-aos-delay="100"/>
                <v-img src="/images/sub/pitching-festa/process-img.png" class="d-none d-md-block"  data-aos="fade-up" data-aos-delay="100"/>
            </page-section>
            <!-- E: 프로세스 -->

            <!-- S: 개최 성과 -->
            <page-section title="개최 성과">
                <template #text>
                    <div v-html="festa.section4.txt[0]" />
                </template>
                <v-row justify="center" class="row--lg">
                    <v-col cols="12" md="" data-aos="fade-up" data-aos-delay="100">
                        <div class="d-flex justify-center">
                            <div>
                                <v-img :aspect-ratio="104 / 102" max-width="104" src="/images/sub/pitching-festa/perfomance-icon.png" />
                                <div class="mt-16px mt-md-20px">
                                    <div class="tit tit--xs mb-12px">발굴기업</div>
                                    <div class="d-flex align-center tit tit--xs">총<strong class="tit--xl px-6px px-md-10px">203</strong>개사 +</div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="" data-aos="fade-up" data-aos-delay="200">
                        <div class="d-flex justify-center">
                            <div>
                                <v-img :aspect-ratio="104 / 102" max-width="104" src="/images/sub/pitching-festa/perfomance-icon2.png" />
                                <div class="mt-16px mt-md-20px">
                                    <div class="tit tit--xs mb-12px">투자유치금액</div>
                                    <div class="d-flex align-center tit tit--xs">총<strong class="tit--xl px-6px px-md-10px">1,883</strong>억원</div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="" data-aos="fade-up" data-aos-delay="300">
                        <div class="d-flex justify-center">
                            <div>
                                <v-img :aspect-ratio="116 / 100" max-width="116" src="/images/sub/pitching-festa/perfomance-icon3.png" />
                                <div class="mt-16px mt-md-20px">
                                    <div class="tit tit--xs mb-12px">협업 연계</div>
                                    <div class="d-flex align-center tit tit--xs">총<strong class="tit--xl px-6px px-md-10px">50</strong>건 +</div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </page-section>
            <!-- E: 개최 성과 -->

            <!-- S: 프로그램 -->
            <page-section title="프로그램" class="grey lighten-5">
                <template #text>
                    <div v-html="festa.section5.txt[0]" />
                </template>

                <div class="program-container">
                    <v-row class="row--large">
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="100">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program01.png" alt="이미지"/></span>
                                <h4 class="program-title">피칭데이</h4>
                                <p class="desc">
                                    피칭을 통한 우수기업 시상
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="200">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program02.png" alt="이미지"/></span>
                                <h4 class="program-title">전시 지원</h4>
                                <p class="desc">
                                    디지털유통대전 내 스타트업 제품과<br />
                                    서비스등을 소개할 수 있는 부스전시공간 마련
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="300">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program03.png" alt="이미지"/></span>
                                <h4 class="program-title">네트워킹</h4>
                                <p class="desc">
                                    스타트업과 유관 기업들의<br />
                                    미팅자리 마련
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="200">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program04.png" alt="이미지"/></span>
                                <h4 class="program-title">
                                    풀필먼트 사업 연계
                                </h4>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="300">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program05.png" alt="이미지"/></span>
                                <h4 class="program-title">
                                    기술 실증 지원
                                </h4>
                            </div>
                        </v-col>
                        <v-col data-aos="fade-up" data-aos-delay="400">
                            <div class="card">
                                <span class="icon"><img src="/images/sub/pitching-festa/program06.png" alt="이미지"/></span>
                                <h4 class="program-title">
                                    데이터 활용 지원
                                </h4>
                                <p class="desc">
                                    유통데이터를 활용한 신서비스 개발<br />
                                    및 사업화 지원
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </page-section>
            <!-- E: 프로그램 -->

            <!-- S: 파트너 -->
            <page-section title="Partners" class="page-section--last">
                <template #text>
                    <div v-html="festa.section6.contents.frame2211.txt[0]" />
                </template>

                <template v-for="(logoItems, row) in festa.section6.contents.frame2302.logoList">
                    <v-row :key="row" class="ma-n4px my-md-n20px">
                        <template v-for="({ src, url }, col) in logoItems">
                            <v-col cols="6" sm="4" md="3" class="pa-4px py-md-20px" :key="col" data-aos="fade-up" data-aos-delay="100">
                                <v-card tile flat :href="url" target="_blank">
                                    <v-img contain :height="$vuetify.breakpoint.mdAndDown ? '60' : '96'" :src="src" />
                                </v-card>
                            </v-col>
                        </template>
                        <v-spacer />
                    </v-row>
                </template>
            </page-section>
            <!-- E: 파트너 -->
        </template>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";

import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import TablePrimary from "@/components/dumb/table-primary.vue";
import TablePrimaryRow from "@/components/dumb/table-primary-row.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TablePrimary,
        TablePrimaryRow,
        PopupLayer,
        LocaleSelect,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {
            festa: null,

            categoriesYoutube,
            categoriesReport,
            categoriesForms,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { festa } = await api.v1.kea.festa.get();
            this.festa = festa;
        },
    },
};
</script>
